// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__eR9yP","textArea":"styles_textArea__J8-0s","actions":"styles_actions__ZRcRG","iconButton":"styles_iconButton__dlXMy"};